import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";

export const makeAssType_32 = ({ book }) => {
    const current = book.selectedCurrentUserAssign;
    const bookData = current?.book || {};
    const bookAsin = (() => {
        switch (Number(current?.booksTypeId)) {
            case 1:
                return bookData.kindle_asin || bookData.paper_back_asin || bookData.hard_cover_asin || "Not found";
            case 2:
                return bookData.paper_back_asin || bookData.kindle_asin || bookData.hard_cover_asin || "Not found";
            case 3:
                return bookData.hard_cover_asin || bookData.paper_back_asin || bookData.kindle_asin || "Not found";
            case 4:
                return bookData.audio_audible_asin || bookData.audible_asin || bookData.kindle_asin || "Not found";
            default:
                return bookData.kindle_asin || bookData.paper_back_asin || bookData.hard_cover_asin || "Not found";
        }
    })();

    const steps = {
        STEP1: {
            book_asin: bookAsin,
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",
            icon1: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title1: "Open book and set rating",
            description1: "Open the book page and leave a star rating without writing a text review. Then click Next Step.",
            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of rating",
            description2: "Upload a clear screenshot showing the completed star rating.",
            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your uploaded file.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve assignment",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your task.",
            full_title1: "Go to the assigned Amazon book page and leave a star rating.",
            full_subtitle1: "Make sure you're logged into your Amazon account before completing the action.",
            full_description1: (
                <p>
                    Open the assigned <b>book page</b> on Amazon and leave a <b>star rating without text</b>.
                    After the rating is visible on screen, take a clear screenshot as proof.
                </p>
            ),
            full_title2: "Upload your star rating screenshot",
            full_subtitle2: "The book page and completed star rating must be visible.",
            full_description2: (
                <p>
                    Please upload a <b>clear screenshot</b> showing that the star rating was completed for the assigned book.
                    Make sure the image is not blurry or cropped, otherwise it may be rejected.
                </p>
            ),
            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, submit this assignment so that our team can begin verification.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify your screenshot and confirm the action.
                    If anything is missing, we'll ask you to re-upload or provide additional details.
                </p>
            ),
            full_title4: "Awaiting verification",
            full_subtitle4: "We'll review your screenshot and finalize this assignment.",
            full_description4: (
                <p>
                    Once the proof is confirmed, we'll record it and mark the assignment as completed.
                    Thank you for providing a clear proof screenshot.
                </p>
            ),
        },
        STEP2: {
            book_asin: bookAsin,
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Open book and set rating",
            description1: "You have completed this step!",
            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Upload proof of rating",
            description2: "Upload a clear screenshot showing the completed star rating.",
            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your uploaded file.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve assignment",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your task.",
            full_title2: "Upload your star rating screenshot",
            full_subtitle2: "The book page and completed star rating must be visible.",
            full_description2: (
                <p>
                    Please upload a <b>clear screenshot</b> showing that the star rating was completed for the assigned book.
                    Make sure the image is not blurry or cropped, otherwise it may be rejected.
                </p>
            ),
            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, submit this assignment so that our team can begin verification.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify your screenshot and confirm the action.
                    If anything is missing, we'll ask you to re-upload or provide additional details.
                </p>
            ),
            full_title4: "Awaiting verification",
            full_subtitle4: "We'll review your screenshot and finalize this assignment.",
            full_description4: (
                <p>
                    Once the proof is confirmed, we'll record it and mark the assignment as completed.
                    Thank you for providing a clear proof screenshot.
                </p>
            ),
        },
        STEP3: {
            book_asin: bookAsin,
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Open book and set rating",
            description1: "You have completed this step!",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of rating",
            description2: "Your proof has been successfully uploaded.",
            icon3: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your uploaded file.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Approve assignment",
            description4: "We are waiting for you to finish the previous three steps. Then we can approve your task.",
            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, submit this assignment so that our team can begin verification.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify your screenshot and confirm the action.
                    If anything is missing, we'll ask you to re-upload or provide additional details.
                </p>
            ),
            full_title4: "Awaiting verification",
            full_subtitle4: "We'll review your screenshot and finalize this assignment.",
            full_description4: (
                <p>
                    Once the proof is confirmed, we'll record it and mark the assignment as completed.
                    Thank you for providing a clear proof screenshot.
                </p>
            ),
        },
        STEP4: {
            book_asin: bookAsin,
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Open book and set rating",
            description1: "You have completed this step!",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of rating",
            description2: "Your proof has been successfully uploaded.",
            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted.",
            icon4: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title4: "Approve assignment",
            description4: "We received your submission and will verify it soon.",
            full_title4: "Awaiting verification",
            full_subtitle4: "We'll review your screenshot and finalize this assignment.",
            full_description4: (
                <p>
                    Once the proof is confirmed, we'll record it and mark the assignment as completed.
                    Thank you for providing a clear proof screenshot.
                </p>
            ),
        },
        STEP5: {
            book_asin: bookAsin,
            review_link: book.selectedCurrentUserAssign?.review_link || "Not found",
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Open book and set rating",
            description1: "You have completed this step!",
            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of rating",
            description2: "We've reviewed and validated your proof.",
            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Assignment submitted successfully and verified.",
            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Assignment confirmed!",
            description4: "Congratulations, your star rating assignment is fully confirmed!",
            full_title5: "Assignment closed and verified!",
            full_subtitle5: "Everything looks good - the assignment has been finalized.",
            full_description5: (
                <p>
                    This star rating assignment has passed verification and is now officially closed.
                    The corresponding <b>Virt</b> reward was credited at the moment you took the assignment.
                </p>
            ),
        },
    };

    return {
        1: steps,
        2: steps,
        3: steps,
        4: steps,
        5: steps,
    };
};
